import React from 'react';
import { getData } from '../utils/Utils';
import * as DATA from '../utils/Data';
import FactArticle from '../components/FactArticle';

export default class FactArticleContainer extends React.Component {
  constructor() {
    super();
    this.state = { factItem: [] };
  }

  componentDidMount() {
    getData(
      `${DATA.API_URL}/facts/rows/${this.props.match.params.id}`,
      json => {
        this.setState({ factItem: json.data });
      }
    );
  }

  render() {
    return <FactArticle factItem={this.state.factItem} />;
  }
}



// WEBPACK FOOTER //
// ./src/containers/FactArticleContainer.js